// RETAIL PRICE BOX
/*
document.addEventListener('DOMContentLoaded', function () {
  function formatNumber(numStr) {
    var parts = numStr.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var decPart = parts[1] ? parts[1].padEnd(2, '0') : '00';
    return intPart + ',' + decPart;
  }

  function reformatPrice(priceSpan) {
    var text = priceSpan.textContent;
    var match = text.match(/kr\s*([\d.,]+)/i);
    if (match) {
      var formatted = formatNumber(match[1]);
      var reformatted = text.replace(/kr\s*[\d.,]+/i, formatted + ' kr');
      if (reformatted !== text) {
        priceSpan.textContent = reformatted;
      }
    }
  }

  function watchPriceSpan(block) {
    var priceSpan = block.querySelector('.b2b-price');
    if (!priceSpan) return;

    reformatPrice(priceSpan);

    var priceObserver = new MutationObserver(function () {
      priceObserver.disconnect();
      reformatPrice(priceSpan);
      priceObserver.observe(priceSpan, { childList: true, characterData: true, subtree: true });
    });
    priceObserver.observe(priceSpan, { childList: true, characterData: true, subtree: true });
  }

  function tryMove() {
    var block = document.querySelector('.logged-in .retail-price-container');
    var priceCard = document.querySelector('.card-product-price');
    var priceRegular = priceCard ? priceCard.querySelector('.price-regular') : null;

    if (block && priceRegular) {
      priceRegular.insertAdjacentElement('afterend', block);
      block.style.setProperty('display', 'block', 'important');
      watchPriceSpan(block);
      return true;
    }
    return false;
  }

  if (tryMove()) return;

  var observer = new MutationObserver(function () {
    if (tryMove()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(function () {
    observer.disconnect();
  }, 10000);
});
*/


// LANGUAGE SWITCHER
 (function () {
    document.querySelectorAll('[data-language-switcher]').forEach(function (root) {
      var toggle = root.querySelector('[data-language-switcher-toggle]');
      var menu = root.querySelector('[data-language-switcher-menu]');

      function closeMenu() {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      function openMenu() {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.hidden) {
          openMenu();
        } else {
          closeMenu();
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          closeMenu();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMenu();
        }
      });
    });
  })();

   (function () {
    document.querySelectorAll('[data-language-switcher-click]').forEach(function (root) {
      var toggle = root.querySelector('[data-language-switcher-toggle-click]');
      var menu = root.querySelector('[data-language-switcher-menu]');

      function closeMenu() {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }

      function openMenu() {
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          closeMenu();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMenu();
        }
      });
    });
  })();

// ADDONS POPUP
function applyCustomerDiscount() {
  // Get customer discount from body
  const customerDiscount = document.body.getAttribute('customer-discount');

  if (!customerDiscount) {
    console.log('No customer discount found on body element');
    return; // No discount to apply
  }

  const discountPercent = parseFloat(customerDiscount);

  if (isNaN(discountPercent) || discountPercent <= 0) {
    console.log('Invalid discount percentage:', customerDiscount);
    return; // Invalid discount value
  }

  // Get the popup
  const popup = document.querySelector('.lb-popup');

  if (!popup) {
    console.log('lb-popup not found');
    return; // Popup not found
  }

  // Get all price spans with lb-default-price attribute inside the popup
  const priceSpans = popup.querySelectorAll('span.lb-price-sale-price[lb-default-price]');

  console.log(`Found ${priceSpans.length} price elements in lb-popup. Applying ${discountPercent}% discount.`);

  priceSpans.forEach((span, index) => {
    // Check if we already stored the original price
    let originalPriceCents;

    if (span.hasAttribute('lb-original-price')) {
      // Use the stored original price
      originalPriceCents = parseFloat(span.getAttribute('lb-original-price'));
    } else {
      // First time - store the current lb-default-price as the original
      originalPriceCents = parseFloat(span.getAttribute('lb-default-price'));
      span.setAttribute('lb-original-price', originalPriceCents.toString());
    }

    if (isNaN(originalPriceCents)) {
      console.warn(`Invalid price at index ${index}`);
      return;
    }

    // Calculate the discounted price in cents (from the ORIGINAL price)
    const discountedPriceCents = Math.round(originalPriceCents * (1 - discountPercent / 100));

    // Convert to euros (divide by 100)
    const discountedPriceEuros = discountedPriceCents / 100;

    // Format with comma as decimal separator and € symbol (European format)
    const formattedPrice = discountedPriceEuros.toFixed(2).replace('.', ',') + ' €';

    console.log(`Product ${index + 1}: ${(originalPriceCents/100).toFixed(2)}€ -> ${discountedPriceEuros.toFixed(2)}€ (${formattedPrice})`);

    // Update the lb-price attribute
    span.setAttribute('lb-price', formattedPrice);

    // Update the visible text content
    span.textContent = formattedPrice;

    // Update lb-default-price to the new discounted value
    span.setAttribute('lb-default-price', discountedPriceCents.toString());
  });

  console.log('Discount application complete!');
}

// MutationObserver to detect when lb-popup appears in the DOM
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) { // Element node
        // Check if the added node is the popup
        if (node.classList && node.classList.contains('lb-popup')) {
          console.log('lb-popup detected via MutationObserver');
          setTimeout(applyCustomerDiscount, 100); // Small delay to ensure DOM is ready
        }
        // Check if the added node contains the popup
        else if (node.querySelector) {
          const popup = node.querySelector('.lb-popup');
          if (popup) {
            console.log('lb-popup detected inside added node');
            setTimeout(applyCustomerDiscount, 100);
          }
        }
      }
    });
  });
});

// Start observing the document body for DOM changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Check on page load in case popup is already there
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded - checking for existing lb-popup');
  setTimeout(applyCustomerDiscount, 500);
});

// Additional fallback: check when popup becomes visible (class/style changes)
const visibilityObserver = new MutationObserver(function(mutations) {
  const popup = document.querySelector('.lb-popup');
  if (popup) {
    const isVisible = popup.offsetParent !== null ||
                     window.getComputedStyle(popup).display !== 'none';

    if (isVisible) {
      console.log('lb-popup is now visible');
      applyCustomerDiscount();
    }
  }
});

// Start observing for attribute/class changes that might show the popup
setTimeout(function() {
  const popup = document.querySelector('.lb-popup');
  if (popup) {
    visibilityObserver.observe(popup, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
}, 1000);

// Separate function ONLY for the total price in lb-bundle-cta-total-cont
function applyDiscountToTotal() {
  // Get customer discount from body
  const customerDiscount = document.body.getAttribute('customer-discount');

  if (!customerDiscount) {
    return;
  }

  const discountPercent = parseFloat(customerDiscount);

  if (isNaN(discountPercent) || discountPercent <= 0) {
    return;
  }

  // Find the total container
  const totalContainer = document.querySelector('.lb-bundle-cta-total-cont');

  if (!totalContainer) {
    return;
  }

  // Find the price span ONLY inside the total container
  const totalPriceSpan = totalContainer.querySelector('span.lb-price-sale-price[lb-default-price]');

  if (!totalPriceSpan) {
    return;
  }

  // Get the current price from lb-default-price
  const currentPriceCents = parseFloat(totalPriceSpan.getAttribute('lb-default-price'));

  if (isNaN(currentPriceCents)) {
    return;
  }

  // Apply discount
  const discountedPriceCents = Math.round(currentPriceCents * (1 - discountPercent / 100));
  const discountedPriceEuros = discountedPriceCents / 100;
  const formattedPrice = discountedPriceEuros.toFixed(2).replace('.', ',') + ' €';

  console.log(`Total: ${(currentPriceCents/100).toFixed(2)}€ -> ${discountedPriceEuros.toFixed(2)}€`);

  // Update the total price display
  totalPriceSpan.setAttribute('lb-price', formattedPrice);
  totalPriceSpan.textContent = formattedPrice;
}

// MutationObserver specifically for the total block
const totalBlockObserver = new MutationObserver(function(mutations) {
  console.log('Total block changed!');
  // Small delay to let the original value populate first
  setTimeout(applyDiscountToTotal, 50);
});

// Function to start watching the total block
function startWatchingTotal() {
  const totalContainer = document.querySelector('.lb-bundle-cta-total-cont');

  if (totalContainer) {
    totalBlockObserver.observe(totalContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['lb-price', 'lb-default-price']
    });

    console.log('Started watching lb-bundle-cta-total-cont');

    // Apply discount immediately to current value
    applyDiscountToTotal();
  }
}

// Wait for the total block to appear
const waitForTotal = new MutationObserver(function(mutations) {
  const totalContainer = document.querySelector('.lb-bundle-cta-total-cont');
  if (totalContainer) {
    startWatchingTotal();
    waitForTotal.disconnect(); // Stop looking once found
  }
});

// Start watching for the total block to appear
waitForTotal.observe(document.body, {
  childList: true,
  subtree: true
});

// Also check on page load
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(startWatchingTotal, 500);
});

// GET CART TOTAL
function extractCurrencySymbol(str) {
  // Capture currency words or symbols such as €, kr, $, £
  var match = str.trim().match(/[^0-9.,\s]+/g);
  return match ? match.join(' ') : '';
}

function parsePrice(str) {
  // Trim and remove NBSP / spaces
  var s = str.replace(/ /g, '').trim();

  // Extract currency (letters or €)
  var currencyMatch = s.match(/[€A-Za-z]+$/);
  var currency = currencyMatch ? currencyMatch[0] : '';

  // Keep digits, dots, commas only
  s = s.replace(currency, '').replace(/[^\d.,]/g, '');

  var commaCount = (s.match(/,/g) || []).length;
  var dotCount   = (s.match(/\./g) || []).length;

  if (commaCount && dotCount) {
    // Both present → last one is decimal
    if (s.lastIndexOf('.') > s.lastIndexOf(',')) {
      // 14,811.30
      s = s.replace(/,/g, '');
    } else {
      // 2.272,50
      s = s.replace(/\./g, '').replace(',', '.');
    }
  } else if (commaCount && !dotCount) {
    // Only comma → decimal
    s = s.replace(',', '.');
  }
  // Only dot or none → already valid

  var value = Number(s);

  return {
    value: isNaN(value) ? 0 : value,
    currency: currency
  };
}


function formatPrice(value, currency) {
  return (
    value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) +
    ' ' +
    currency
  );
}

function updateRealCartTotal() {
  var items = document.querySelectorAll('.cart-items .cart-item');
  var total = 0;
  var currency = '';

  items.forEach(function(item) {
    var priceEl = item.querySelector('.price--end');
    if (!priceEl) return;

    var parsed = parsePrice(priceEl.textContent);

    if (!currency) currency = parsed.currency;
    total += parsed.value;
  });

  var out = document.querySelector('.real-cart-total');
  if (out) {
    out.textContent = formatPrice(total, currency);
  }
}

// Run immediately
updateRealCartTotal();

// Support dynamic cart updates
document.addEventListener('cart:updated', updateRealCartTotal);

// UPDATE VARIANT WHOLESALE PRICE
document.addEventListener("DOMContentLoaded", function() {
  // Select all variant inputs or swatches
  const variantInputs = document.querySelectorAll(
    'input[name][form^="product-form-"], .product__color-swatch'
  );

  // Select price wrapper (main container for product price)
  const priceWrapper = document.querySelector('[data-price-wrapper]');
  if (!priceWrapper) return;

  // Define price elements inside wrapper
  const priceEl = priceWrapper.querySelector('.price.heading_weight, .price.heading-style');
  const comparePriceEl = priceWrapper.querySelector('.compare-price');

  /**
   * Parse a European-styled price string into a Number.
   * Handles examples like:
   *   "3.522,00 EUR" -> 3522
   *   "3522,00"      -> 3522
   *   "3522.00"      -> 3522
   *   "3 522,00"     -> 3522
   *
   * Returns NaN if parsing fails.
   */
  function parseEuropeanPrice(str) {
    if (str == null) return NaN;
    // Keep digits, dot, comma and minus sign
    let s = String(str).replace(/[^\d.,-]/g, '').trim();
    if (!s) return NaN;

    const hasDot = s.indexOf('.') !== -1;
    const hasComma = s.indexOf(',') !== -1;

    if (hasDot && hasComma) {
      // Common European format: dots as thousand separators, comma as decimal
      // e.g. "3.522,00" -> "3522.00"
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (hasComma && !hasDot) {
      // e.g. "3522,00" -> "3522.00"
      s = s.replace(',', '.');
    } else if (hasDot && !hasComma) {
      // Ambiguous: could be "3.522" (thousand) or "3522.00" (decimal)
      // Heuristic: if there are exactly 3 digits after the dot -> treat dot as thousands separator
      // otherwise treat as decimal separator.
      const parts = s.split('.');
      const lastLen = parts[parts.length - 1].length;
      if (lastLen === 3 && parts.length > 1) {
        // treat dot as thousands separator
        s = s.replace(/\./g, '');
      } // else treat dot as decimal point and keep as-is
    }

    // Now s should be in "1234.56" or "1234" form
    const num = Number(s);
    return isNaN(num) ? NaN : num;
  }

  // Format number to FI/EU format with EUR symbol, preserving decimal places
  function formatPrice(priceString) {
    if (priceString == null || priceString === '' || priceString === '0' || priceString === 'NaN') return '';
    const num = parseEuropeanPrice(priceString);
    if (isNaN(num)) return priceString; // fallback to original input if we cannot parse

    // Determine fraction digits from original string if possible
    // (so 3522.00 -> 2 fraction digits; 3522 -> 0)
    let fracDigits = 0;
    const cleaned = String(priceString).replace(/[^\d.,-]/g, '').trim();
    if (cleaned.indexOf(',') !== -1) {
      const decimals = cleaned.split(',').pop();
      fracDigits = Math.min(6, Math.max(0, decimals.length)); // clamp to reasonable range
    } else if (cleaned.indexOf('.') !== -1 && cleaned.split('.').length > 1) {
      const decimals = cleaned.split('.').pop();
      // If string originally had both separators we've already normalized; if only dot existed treat as decimals
      fracDigits = Math.min(6, Math.max(0, decimals.length));
    } else {
      fracDigits = 0;
    }

    return num.toLocaleString('fi-FI', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: fracDigits,
      maximumFractionDigits: fracDigits
    });
  }

  // Simple fade utility
  function fadeOut(el, duration = 0) {
    el.style.transition = `opacity ${duration}ms ease`;
    el.style.opacity = 1;
    requestAnimationFrame(() => { el.style.opacity = 0; });
    return new Promise(resolve => setTimeout(resolve, duration));
  }

  function fadeIn(el, duration = 500) {
    el.style.transition = `opacity ${duration}ms ease`;
    el.style.opacity = 0;
    requestAnimationFrame(() => { el.style.opacity = 1; });
  }

  // Handle variant click
  async function updateWholesalePrice(el) {
    const wholesalePrice = el.dataset.wholesalePrice || '';
    const wholesaleCompareAt = el.dataset.wholesaleCompareAtPrice || '';

    if (!wholesalePrice && !wholesaleCompareAt) return;

    // Don't overwrite a correctly-hidden ("price on request") price with a raw zero value
    const numericWholesalePrice = parseFloat(String(wholesalePrice).replace(/[^\d.,-]/g, '').replace(',', '.'));
    if (!isNaN(numericWholesalePrice) && numericWholesalePrice === 0) return;

    // Fade out both price elements first
    if (priceEl) await fadeOut(priceEl, 0);
    if (comparePriceEl) await fadeOut(comparePriceEl, 0);

    // Update price content
    if (priceEl) {
      priceEl.textContent = wholesalePrice;
    }

    if (comparePriceEl) {
      if (wholesaleCompareAt && wholesaleCompareAt !== wholesalePrice) {
        comparePriceEl.textContent = wholesaleCompareAt;
        const regular = comparePriceEl.closest('.price-regular');
        if (regular) regular.style.display = 'block';
      } else {
        const regular = comparePriceEl.closest('.price-regular');
        if (regular) regular.style.display = 'none';
      }
    }

    // Fade in after updating
    if (priceEl) fadeIn(priceEl, 500);
    if (comparePriceEl) fadeIn(comparePriceEl, 500);
  }

  // Listen for variant changes (radio or swatch click)
  variantInputs.forEach((input) => {
    input.addEventListener('change', function() {
      const label = document.querySelector(`label[for="${this.id}"]`);
      if (label && label.dataset.wholesalePrice) {
        updateWholesalePrice(label);
      }
    });
  });

  // Also listen for direct label clicks (for swatches not tied to inputs)
  const swatchLabels = document.querySelectorAll('.product__color-swatch');
  swatchLabels.forEach(label => {
    label.addEventListener('click', function() {
      if (this.dataset.wholesalePrice) {
        setTimeout(() => {
          updateWholesalePrice(this);
        }, 500);
      }
    });
  });

});

// RELOAD UPON VARIANT CHANGE FOR GIFT PRODUCT
$('.template-lahjakortti .product__color-swatches--js.product__item-option').on('click', function() {
        setTimeout(() => {
          location.reload();
        }, 500);
});

// HOMEPAGE VIDEO
window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.querySelector("#shopify-section-template--23312061890855__multi_content_gciKfF video")?.play();
  }, 3000);
});

// EXTERNAL LINKS
Array.from(document.links).forEach((link) => {
  if (link.hostname !== window.location.hostname) {
    link.target = "_blank";
    link.rel = "noreferrer noopener";
  }
});

// PRINT PAGE
$(".print-btn").on("click", function () {
  const hideSelectors = [
    '.media-thumb-swiper',
    '#shopify-block-AbTZhdGhidWg4QVNze__judge_me_reviews_preview_badge_DA7AKV',
    '.more-prod-btn', '#full-info-btn', '#files-btn',
    '.product-detail__buy-buttons', '#request-offer', '#recommendations', '#files',
    '.product-addons', '.tech-item img', '.form__label',
    '.zoom_light_box', '.icon_plus-animation', '.usps-container', 'iframe',
    '.product-detail__meta', 'variant-radios-detail',
    '.product-detail__price', '.variants-list', '.swatches-text'
  ].join(', ');

  $(hideSelectors).hide();
  $('#tech-data').addClass("active");
  $('spark-pdp').addClass("print").addClass("hidden-important");
  $('.color-item').removeClass("hidden-important");
  $('#tech-data .collapsible-content, .brochure-logo, .brochure-url').show();
  $('.media-main-swiper').addClass("w-full-important");

  setTimeout(() => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    html2canvas($(".main-product")[0], {
      useCORS: true,
      allowTaint: true,
      scale: 2,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pageTitle = document.title || 'Esite';
      const pageUrl = window.location.href;

      doc.addImage(imgData, "JPG", 10, 10, imgWidth, imgHeight);
      doc.setFontSize(6);
      doc.textWithLink(`Tuotesivu: ${pageUrl}`, 10, imgHeight + 20, { url: pageUrl });
      doc.setFontSize(10);
      doc.text("Lehtovuori Oy | Hopeatie 4, Ylöjärvi | +358 (0)3 7846 777 | info@lehtovuori.fi | www.lehtovuori.fi", 10, imgHeight + 25);
      doc.save(`LEHTOVUORI - ${pageTitle}.pdf`);

      $(hideSelectors).show();
      $('#tech-data').removeClass("active");
      $('spark-pdp').removeClass("print hidden-important");
      $('.color-item').addClass("hidden-important");
      $('#tech-data .collapsible-content, .brochure-logo, .brochure-url').hide();
      $('.media-main-swiper').removeClass("w-full-important");
    });
  }, 500);
});

// SLIDING LINKS
$(".sliding-link").on("click", function (e) {
  e.preventDefault();
  const aid = $(this).attr("href");
  $('html,body').animate({ scrollTop: $(aid).offset().top - 80 }, 'slow');
});

// REFRESH CART
$(".template-cart .quantity__button").on("click", function (e) {

  setTimeout(() => {
    location.reload();
  }, 1000);
});

$(".template-cart .quantity-input").on("input", function (e) {

  setTimeout(() => {
    location.reload();
  }, 2000);
});

$(".template-cart .cart-remove").on("click", function (e) {

  setTimeout(() => {
    location.reload();
  }, 1000);
});



// REQUEST OFFER TEXTAREA FILLING
$("#request-offer").on("click", function (e) {
  e.preventDefault();
  $(".product-addons__ask-question").click();
  console.log($(".product-addons__ask-question"));

  const textarea = document.querySelector(".form-products textarea");
  if (!textarea) return;

  if (document.body.classList.contains("product")) {
    const title = window.productData?.title || "Unknown Product";
    const url = window.productData?.url || window.location.href;
    textarea.value = `Product Title: ${title}\nProduct URL: ${url}`;
  }

  if (document.body.classList.contains("template-cart")) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartDetails = cart.items.map(item =>
          `Product: ${item.title}\nQuantity: ${item.quantity}\nPrice: ${item.line_price / 100} ${cart.currency}\nURL: ${item.url}`
        ).join('\n\n');
        textarea.value = `Cart Items:\n\n${cartDetails}`;
        console.log(textarea.value);
      });
  }
});

// FILES TOGGLE
$("#files-btn").on("click", () => {
  $("#files .open-children-toggle").click();
});

// DOCUMENT READY EVENTS
$(document).ready(function () {
  if (window.matchMedia("only screen and (max-width: 760px)").matches) {
    $(".product-detail__variant-picker.desktop").remove();
  }

  // COMPARE BOX TOGGLE
  let hideTimeout;
  $("button-compare").on("click", function () {
    $("#compare-box").addClass("show");
    hideTimeout = setTimeout(() => {
      $("#compare-box").removeClass("show");
    }, 4000);
  });

  $("#compare-box").hover(
    () => clearTimeout(hideTimeout),
    () => {
      hideTimeout = setTimeout(() => {
        $("#compare-box").removeClass("show");
      }, 4000);
    }
  );
});